// src/components/landing/Testimonials.tsx
"use client";

import { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";

// Minimal type definitions for jQuery and Slick
interface JQueryStatic {
  (selector: string): JQuery;
  fn: { slick?: (options: SlickOptions | "unslick") => void };
}

interface JQuery {
  slick(options: SlickOptions | "unslick"): void;
  hasClass(className: string): boolean;
}

interface SlickOptions {
  dots?: boolean;
  arrows?: boolean;
  infinite?: boolean;
  speed?: number;
  slidesToShow?: number;
  slidesToScroll?: number;
  autoplay?: boolean;
  autoplaySpeed?: number;
  responsive?: Array<{
    breakpoint: number;
    settings: Partial<SlickOptions>;
  }>;
}

declare global {
  interface Window {
    jQuery: JQueryStatic;
    $: JQueryStatic; // Alias for jQuery
  }
}

export default function Testimonials() {
  useEffect(() => {
    if (typeof window !== "undefined" && window.jQuery && window.jQuery.fn.slick) {
      const $ = window.jQuery;

      const $slider = $(".clientSliderSix");
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }

      $slider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      return () => {
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }
      };
    }
  }, []);

  return (
    <div className="client-feedback-slider-six mt-200 md-mt-120" id="feedback">
      <div className="inner-container">
        <div className="title-style-thirteen text-center mb-50 md-mb-20" data-aos="fade-up">
          <div className="upper-title">Testimonials</div>
          <h2>
            They <span>love us & we<Image src="/images/shape/line-shape-14.svg" className="y-line" alt="" width={100} height={100} /></span> love them
          </h2>
        </div>
        <div className="clientSliderSix style-two">
          <div className="item">
            <div className="feedback-wrapper" data-aos="fade-up">
              <p>“I can’t say enough good things about the Avelon team! They absolutely nailed it. They took all the stress out of the process and we got the media coverage we were aiming for. The results exceeded…”</p>
              <Link href="https://casavo.com/en/" target="_blank" className="d-flex align-items-center">
                <Image src="/images/reviews/giorgio.webp" alt="" className="avatar av-icons" width={100} height={100} />
                <h6 className="name">
                  Giorgio Tinacci<br />
                  <span id="test-comp">Casavo</span><span> - Founder & CEO</span>
                </h6>
              </Link>
            </div>
          </div>
          <div className="item">
            <div className="feedback-wrapper" data-aos="fade-up">
              <p>“I really appreciated how straightforward and smooth the whole process was. Avelon PR helped us get noticed by the right people, and their team was always available to answer questions…”</p>
              <Link href="https://wayray.com/" target="_blank" className="d-flex align-items-center">
                <Image src="/images/reviews/daria.webp" alt="" className="avatar av-icons" width={100} height={100} />
                <h6 className="name">
                  Daria Mikheeva<br />
                  <span id="test-comp">WayRay</span><span> - Project Manager</span>
                </h6>
              </Link>
            </div>
          </div>
          <div className="item">
            <div className="feedback-wrapper" data-aos="fade-up">
              <p>“At Blueground, it’s essential for us to communicate effectively with an international audience. Avelon delivered exactly what we needed — strategic media placements that aligned with…”</p>
              <Link href="https://www.theblueground.com/" target="_blank" className="d-flex align-items-center">
                <Image src="/images/reviews/thanos.webp" alt="" className="avatar av-icons" width={100} height={100} />
                <h6 className="name">
                  Thanos Geramanis<br />
                  <span id="test-comp">Blueground</span><span> - Partner, COO</span>
                </h6>
              </Link>
            </div>
          </div>
          <div className="item">
            <div className="feedback-wrapper" data-aos="fade-up">
              <p>“Honestly, I was impressed by how simple you guys made it. You’re great at what you do, and it’s clear your company really cares about getting things right. I’d definitely work with you…”</p>
              <Link href="https://www.stadiumgoods.com/" target="_blank" className="d-flex align-items-center">
                <Image src="/images/reviews/john.webp" alt="" className="avatar av-icons" width={100} height={100} />
                <h6 className="name">
                  John McPheters<br />
                  <span id="test-comp">Stadium Goods</span><span> - Co-Founder</span>
                </h6>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}